import Vue from 'vue';

import App from './app.vue';

import Modal from './lib/vuejs-modal/dist/vuejs-modal.common';

import confirm from './lib/vuejs-modal/lib/confirm.vue';
import input from './components/modals/input.vue';

console.log('confirm', confirm)


Vue.use(Modal, {
    modals: {
        confirm,
        input
    }
})


const app = new Vue({
    render: h => h(App)
}).$mount('#app');


// WEBPACK FOOTER //
// ./src/index.js